export const NAME_REG_EXP = /^['a-zA-ZÀ-ÖØ-öø-ÿ\s]+$/i
export const PHONE_REG_EXP = /^\+?[0-9()\-\s]+$/
